export default "__VITE_ASSET__BEctWAor__"